<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <slot>
            <v-card-title>
                <v-layout row wrap>
                    <v-col cols="6">
                        {{ title }}
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-btn
                            v-if="hasAddNewButton"
                            color="primary"
                            dark
                            class="ml-2"
                            @click="addNewItem"
                        >
                            Adaugare
                        </v-btn>
                    </v-col>
                    <v-col md="5" sm="12">
                        <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                    </v-col>
                    <v-col v-if="hasRole('admin')" md="4" sm="12">
                        <user-selector v-model="filterByUser" filter-by-role="logistica"></user-selector>
                    </v-col>
                    <v-col md="3" sm="12" class="text-right">
                        <search-field v-model="search"></search-field>
                    </v-col>
                </v-layout>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.transport_supplier="{ item }">
                {{ item.transport_supplier.name }}
            </template>
            <template v-slot:item.document_no="{ item }">
                {{ item.document_number }}
            </template>
            <template v-slot:item.period="{ item }">
                {{ new Date(item.upload_time) | date }}<br/>
                {{ new Date(item.download_time) | date }}
            </template>
            <template v-slot:item.amount="{ item }">
                {{ item.amount }} {{ _.get(currencies, item.currency, 'Necunoscut') }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="downloadPDF(item)"
                >
                    mdi-file-pdf
                </v-icon>
                <v-icon
                    v-if="canUpdate(item)"
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    import UserSelector from "Components/common/UserSelector";
    import ACL from "Mixins/acl";
    export default {
        mixins: [ACL],
        components: {
            PeriodSelector,
            UserSelector
        },
        extends: SmartTable,
        data: () => ({
            title: 'Comenzi de transport',
            loading: true,
            dialog: false,
            headers: [
                { text: 'Numar comanda', value: 'document_no' },
                { text: 'Transportator', value: 'transport_supplier', sortable: false },
                { text: 'Adresa de incarcare', value: 'upload_address' },
                { text: 'Adresa de descarcare', value: 'download_address' },
                { text: 'Perioada', value: 'period' },
                { text: 'Pret', value: 'amount' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            options: {
                sortBy: ['created_at'],
                sortDesc: [true]
            },
            editedIndex: -1,
            editedItem: {
                address: null,
                city: null,
                contact_person: null,
                county_id: null,
                data: {
                    due_days: 0,
                    remarks: null
                },
                remarks: null,
                email: null,
                id: null,
                name: null,
                phone: null,
                trn: null,
                vat_no: null,
            },
            defaultItem: {
                address: null,
                city: null,
                contact_person: null,
                county_id: null,
                data: {
                    due_days: 0,
                    remarks: null
                },
                remarks: null,
                email: null,
                id: null,
                name: null,
                phone: null,
                trn: null,
                vat_no: null,
            },
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            filterByUser: null
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
            currencies () {
                return (new this.$db.Transport).currencies.reduce((total, elem) => {
                    total[elem.id] = elem.text
                    return total
                }, {})
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            filterByUser: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.Transport
                    .orderBy(this.orderBy)
                    .append('document_number')
                    .include('supplier', 'transport_supplier')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            editItem (item) {
                this.$router.push({ name: 'transports-edit', params: { id: item.id } })
            },
            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            addNewItem: function() {
                this.$router.push({ name: 'transports-create' })
            },
            async downloadPDF(item) {
                const downloadEndpoint = new this.$db.Transport({id: item.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                this.loading = false
            }
        },
    };
</script>
